<div class="slide-toggle-container" [ngClass]="[containerCss]">
  <label class="left-toggle-option" [ngClass]="[labelCss, !control.value && activeBold ? 'bold' : '']">
    {{ attrLeftLabel }}
  </label>
  <mat-slide-toggle [matTooltip]="tooltip" [formControl]="control" color="primary">
    <label [ngClass]="[labelCss, control.value && activeBold ? 'bold' : '']">{{ attrRightLabel }}</label>
  </mat-slide-toggle>
</div>
